export default "__VITE_ASSET__9XRXKmCh__"